import React, { useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import axios from "axios";
import Autocomplete from "@material-ui/lab/Autocomplete";
const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "100%",
		maxWidth: "600px",
		margin: "0 auto",
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "800px",
	},
	root: {
		"& .MuiTextField-root": {
			width: "100%",
		},
	},
	button: {
		textAlign: "right",
		marginTop: "30px",
		"& .MuiButton-containedPrimary": {
			marginRight: "10px",
		},
	},

	buttonMarginRight: {
		marginRight: "0.5rem",
	},
}));

export default function DeleteContentNav(props) {
	const classes = useStyles();
	const [open, setOpen] = useState(false);
	const [item, setItem] = useState('');
	const [qty, setQty] = useState(1);

	const handleOpen = () => {
		setOpen(true);
		setQty(1);
	};

	const handleClose = () => {
		setOpen(false);
		setQty(1);
	};
	const {cn_name, cn_id, showModal} = props;


	const  deleteContentNav = async () => {
		const formData = new FormData();
		formData.append("cn_id", cn_id);
		await axios.post(process.env.REACT_APP_API_URL+'delete_content_nav', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
				}
			}).then(function (res) {
				showModal('Deleted Content Nav '+ cn_name, 'success');
				handleClose();
		  	}).catch(function (error) {
				showModal('Something went wrong '+ error.message, 'warning');
				handleClose();
	  		});
	}

	
	const handleSubmit = (e) => {
		e.preventDefault();
		deleteContentNav();
    }

	return (
		<div>
			{/* <Button style={{minWidth: "190px"}} variant="outlined" color="primary" onClick={handleOpen}>
				Delete
			</Button> */}
			<Button variant="contained" style={{backgroundColor: "#E70000", color:"#fff"}} color="primary" onClick={handleOpen}>
				Delete
			</Button>
			<Modal
				aria-labelledby="transition-modal-title"
				aria-describedby="transition-modal-description"
				className={classes.modal}
				open={open}
				onClose={handleClose}
				closeAfterTransition
				BackdropComponent={Backdrop}
				BackdropProps={{
					timeout: 500,
				}}
			>
				<Fade in={open}>
					<div className={classes.paper}>
						<h4 id="transition-modal-title">Delete Content Nav</h4>
						<form onSubmit={handleSubmit} className={classes.root}>
							<Grid container spacing={3}>
								<Grid item xs={9}>
								Are you sure you want to delete this Content Nav? <br/><br/>
								<h4>{cn_name}</h4>
								</Grid>
							</Grid>
							<div className={classes.button}>
								<Button
									variant="contained"
									onClick={handleClose}
									className={classes.buttonMarginRight}
								>
									Cancel
								</Button>
								<Button type="submit" variant="contained" color="primary">
									Delete
								</Button>
							</div>
						</form>
					</div>
				</Fade>
			</Modal>
		</div>
	);
}
